import React, { useState, useEffect } from "react";
import API from "../axios";
import '../style/main.css'
import { useNavigate } from "react-router-dom";
import cake from "../assets/user.png";
import form from "../assets/form.png";
import { motion } from "framer-motion";


const Main = () => {

  const navigate = useNavigate();  
  const empDetails = JSON.parse(localStorage.getItem("empDetails") || "{}");
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [showTop, setShowTop] = useState(false);
  
  const [attendanceData, setAttendanceData] = useState([]);
  const [leaveData, setLeaveData] = useState([]);
  const [offerData, setOfferData] = useState([]);
  const [birthdayData, setBirthdayData] = useState([]);
  const [mdeskData, setMdeskData] = useState([]);
  const [awardData, setAwardData] = useState([]);
  const [contactData, setContactData] = useState([]);
  const [hoLeaveData, setHoLeaveData] = useState([]);
  
  
  const imageUrl = `https://psmport.pothysswarnamahalapp.com/AllStaffsImage/`

    const [loading, setLoading] = useState(false);

  const now = new Date()

  const day = now.toLocaleDateString('en-US', { weekday: 'long' })

  const fullDate = now.toLocaleDateString('en-US', {
    
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  })

   const monthDate = (date) => {
    const d = new Date(date);
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short"
    });
  };

    const fadeUp = {
      hidden: {
        opacity: 0,
        y: 40
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.6
        }
      }
    };

  useEffect(() => {

    const today = new Date();

    // current date
    const lastDay = today
      .toISOString()
      .split("T")[0];

    // 11 days before current date
    const before11Days = new Date();

    before11Days.setDate(today.getDate() - 11);

    const firstDay = before11Days
      .toISOString()
      .split("T")[0];

    fetchAttendance(firstDay, lastDay);
    fetchLeave();
    fetchOffers();
    fetchBirthdays();
    fetchManagement();
    fetchAwards();
    fetchContacts();
    fetchLeave();
    fetchHoLeaves();

  }, []);

  useEffect(() => {

  const handleScroll = () => {

    if (window.scrollY > 250) {

      setShowTop(true);

    } else {

      setShowTop(false);
    }
  };

  window.addEventListener("scroll", handleScroll);

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };

}, []);

const scrollToTop = () => {

  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });

};
    const fetchAttendance = async (fromDate, toDate) => {

      try {

        setLoading(true);

        const res = await API.post("/attendance", {
          empcode: empDetails.employee_code,
          fromDate,
          toDate
        });

        // console.log("data :", res.data);

        setAttendanceData(res.data);

      } catch (err) {

        console.error("Error fetching attendance", err);

      } finally {

        setLoading(false);
      }
    };

      const fetchLeave = async () => {
    try {
      setLoading(true);

      const res = await API.post("/leave", {   // ✅ correct API
        empcode: empDetails.employee_code
      });

      console.log(res.data);
      setLeaveData(res.data);
    } catch (err) {
      console.error("Error fetching leaves", err);
    } finally {
      setLoading(false);
    }
  };

    const fetchOffers = async () => {

    try {

      setLoading(true);

      const res = await API.get(
        "/offers"
      );

      console.log("data : ",res.data);

      setOfferData(res.data);

    } catch (err) {

      console.log(err);

    } finally {

      setLoading(false);

    }
  };

  const fetchBirthdays = async () => {
    try {
      setLoading(true);

      const res = await API.post("/birthdays", 
       { branch: empDetails.branchname }
      );

      console.log("Birthday",res.data);

      setBirthdayData(res.data);
    } catch (err) {
      console.error("Error fetching birthdays", err);
    } finally {
      setLoading(false);
    }
  };

    const fetchManagement = async () => {

    try {

      setLoading(true);

      const res = await API.get(
        "/mDesk"
      );

      console.log("data : ",res.data);

      setMdeskData(res.data);

    } catch (err) {

      console.log(err);

    } finally {

      setLoading(false);

    }
  };

  const fetchAwards = async () => {
    try {
      setLoading(true);
      const res = await API.get("/awards");
      setAwardData(res.data);
      console.log("awards : ",res.data);
    } catch (err) {
      console.error("Error fetching awards", err);
    } finally {
      setLoading(false);
    }
  };

    const fetchContacts = async () => {
        try {
          setLoading(true);
          const res = await API.get("/contacts");
          setContactData(res.data);
          console.log("contact : ",res.data);
        } catch (err) {
          console.error("Error fetching contacts", err);
        } finally {
          setLoading(false);
        }
      };

       const fetchHoLeaves = async () => {
        try {
          setLoading(true);
          const res = await API.get("/ho-leaves");
          setHoLeaveData(res.data);
        } catch (err) {
          console.error("Error fetching leaves", err);
        } finally {
          setLoading(false);
        }
      };

  return (
    <>
        <div className="maindiv">   

      
      <div className='header d-flex justify-content-between align-items-center '>

        <label className='welcomeText'>Welcome in, <span style={{color:"#2B7CD3"}}>POTHYS</span></label>

        <div className='dateBox'>
          <p className='dateText'>{fullDate}</p>          
          <h2 className='dayText'>{day}</h2>
        </div>

      </div>


        <motion.div className="masonry-layout" initial="hidden"
          animate="visible"
          variants={{
            visible: {
              transition: {
                staggerChildren: 0.12
              }
            }
          }}
          >

      {/* LEFT */}
        <motion.div className="box tall Attendance attendanceBox"   variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        >
           <div className="attendanceHeader text-start w-100">
              <h2>Attendance</h2>
            </div>

            {
              loading ? (

                <div className="loadingText">
                  Loading...
                </div>

              ) : (

                <>
                  <div className="attendanceTableWrapper">

                    <table className="attendanceTable">

                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>In</th>
                          <th>Out</th>
                        </tr>
                      </thead>

                      <tbody>

                        {
                        attendanceData.map((item, index) => (

                            <tr key={index}>

                              <td>{item.pdate}</td>

                              <td>
                                {item.pintime || "-"}
                              </td>

                              <td>
                                {item.pouttime || "-"}
                              </td>

                            </tr>
                          ))
                        }

                      </tbody>

                    </table>

                  </div>

                  <button
                    className="viewMoreBt btn btn-md btn-secondary w-100"
                    onClick={() => navigate("/dashboard/attendance")}
                  >
                    View More
                  </button>
                </>
              )
            }
        </motion.div>

        {/* MIDDLE */}
        <motion.div className="middle-group"   variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            >

          <div className="box wide Leave leaveBox">
             <div className="leaveHeader w-100 d-flex justify-content-between">
                <h2>Leave Balance</h2>
                <button className="btn btn-sm btn-secondary rounded-3" onClick={() => navigate("/dashboard/leave")}>View Details</button>
              </div>

              {
                loading ? (

                  <div className="loadingText">
                    Loading...
                  </div>

                ) : (

                  <div className="leaveTableWrapper">

                    <table className="leaveTable">

                      <thead>
                        <tr>
                          <th>Type</th>
                          <th>Credit</th>
                          <th>Used</th>
                          <th>Balance</th>
                        </tr>
                      </thead>

                      <tbody>

                        {
                          leaveData.map((item, index) => (

                            <tr key={index}>

                              <td>{item.LeaveType}</td>

                              <td>{item.Credit}</td>

                              <td>{item.Used}</td>

                              <td className="balanceCell">
                                {item.Balance}
                              </td>

                            </tr>
                          ))
                        }

                      </tbody>

                    </table>

                  </div>
                )
              }

          </div>

          <div className="box large BirthdayBox">

              {/* HEADER */}
              <div className="leaveHeader w-100 d-flex justify-content-between">
                <h2>Birthday</h2>

                <button
                  className="btn btn-sm btn-secondary rounded-3"
                  onClick={() => navigate("/dashboard/birthday")}
                >
                  View Details
                </button>
              </div>

              {/* CONTENT AREA */}
              <div className="birthdayContent">

                {
                  loading ? (
                    <div className="birthdayLoading">
                      Loading...
                    </div>
                  ) : (

                    <div className="birthdayGrid">

                      {
                        birthdayData.slice(0, 8).map((item, index) => {

                          const birthdayDate = new Date(item.date_of_birth);

                          const today = new Date();

                          const birthDay = birthdayDate.getDate();
                          const currentDay = today.getDate();

                          let cardClass = "";

                          // 🎉 Today Birthday
                          if (birthDay === currentDay) {
                            cardClass = "todayBirthday";
                          }

                          // ✨ Past Birthday
                          else if (birthDay < currentDay) {
                            cardClass = "pastBirthday";
                          }

                          return (

                            <div
                              key={item.employee_code}
                              className={`birthdayCard ${cardClass}`}
                            >

                              <div className="birthdayInfo">

                                <div className="birthday-img">
                                    {/* <img src={cake} alt="birthday" /> */}
                                                              <img
                                                                src={`${imageUrl}${parseInt(item.employee_code, 10)}.jpg`}
                                                                alt="birthday"
                                                                onError={(e) => {
                                                                  if (!e.target.dataset.fallback) {
                                                                    e.target.dataset.fallback = "true";
                                                                    e.target.src = `${imageUrl}${parseInt(item.employee_code, 10)}.png`;
                                                                  } else {
                                                                    e.target.src = cake;
                                                                  }
                                                                }}
                                                              />
                                </div>

                                <p className="m-0 text-dark">{item.emp_name}</p>

                                <p className="m-0 text-secondary">{item.department}</p>

                                <span className="text-primary">{monthDate(item.date_of_birth)}</span>

                              </div>

                            </div>
                          );
                        })
                      }

                    </div>
                  )
                }

              </div>

            </div>

        </motion.div>

        {/* RIGHT */}
        <motion.div className="right-group"   variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          >

          <motion.div className="box medium Offers offersBox"   variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              >
             <div className="offersHeader">
                <h2>Offers</h2>

                <button
                  className=" btn-secondary btn btn-sm rounded-3"
                  onClick={() => navigate("/dashboard/offers")}
                >
                  View Details
                </button>
              </div>

              {
                loading ? (

                  <div className="loadingText">
                    Loading...
                  </div>

                ) : (

                  <div
                    id="offerCarousel"
                    className="carousel slide offerCarousel"
                    data-bs-ride="carousel"
                  >

                    <div className="carousel-inner">

                      {
                        offerData.map((item, index) => (

                          <div
                            key={item.id}
                            className={`carousel-item ${index === 0 ? "active" : ""}`}
                          >

                            <div className="offerCard">

                              <img
                                src={`data:image;base64,${item.imageBase}`}
                                alt={item.title}
                                className="offerImage"
                              />

                              <div className="offerContent">

                                <h4 className="offerTitle">
                                  {item.title}
                                </h4>

                                {/* <p className="offerDate">
                                  {
                                    new Date(item.createdDate)
                                      .toLocaleDateString("en-US", {
                                        day: "numeric",
                                        month: "short",
                                        year: "numeric"
                                      })
                                  }
                                </p> */}

                              </div>

                            </div>

                          </div>
                        ))
                      }

                    </div>

                    {/* controls */}

                    <button
                      className="carousel-control-prev"
                      type="button"
                      data-bs-target="#offerCarousel"
                      data-bs-slide="prev"
                    >
                      <span className="carousel-control-prev-icon"></span>
                    </button>

                    <button
                      className="carousel-control-next"
                      type="button"
                      data-bs-target="#offerCarousel"
                      data-bs-slide="next"
                    >
                      <span className="carousel-control-next-icon"></span>
                    </button>

                  </div>
                )
              }

          </motion.div>

          <motion.div className="box small Calender calendarBox"  variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              >

              
                {empDetails.branchname != "CORPORATE" ?
                  
                  <div>
                      <div className="calendarHeader">

                                  <button
                                    className="calendarNavBtn btn bg-light"
                                    onClick={() =>
                                      setCurrentMonth(
                                        new Date(
                                          currentMonth.getFullYear(),
                                          currentMonth.getMonth() - 1,
                                          1
                                        )
                                      )
                                    }
                                  >
                                    <i className="bi bi-chevron-up"></i>
                                  </button>

                                  <div className="calendarTitle">

                                    <h2>Calendar</h2>

                                    <span className="">
                                      {
                                        currentMonth.toLocaleDateString("en-US", {
                                          month: "long",
                                          year: "numeric"
                                        })
                                      }
                                    </span>

                                  </div>

                                  <button
                                    className="calendarNavBtn btn bg-light"
                                    onClick={() =>
                                      setCurrentMonth(
                                        new Date(
                                          currentMonth.getFullYear(),
                                          currentMonth.getMonth() + 1,
                                          1
                                        )
                                      )
                                    }
                                  >
                                    <i className="bi bi-chevron-down"></i>
                                  </button>

                                </div>

                                <div className="calendarGrid">

                                  {/* Day Names */}

                                  {
                                    ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
                                    .map((day, index) => (

                                      <div key={index} className="calendarDayName">
                                        {day}
                                      </div>
                                    ))
                                  }

                                  {
                                    (() => {

                                      const year = currentMonth.getFullYear();
                                      const month = currentMonth.getMonth();

                                      const firstDay = new Date(year, month, 1).getDay();

                                      const totalDays =
                                        new Date(year, month + 1, 0).getDate();

                                      const days = [];

                                      // Empty spaces

                                      for (let i = 0; i < firstDay; i++) {

                                        days.push(
                                          <div
                                            key={`empty-${i}`}
                                            className="calendarEmpty"
                                          ></div>
                                        );
                                      }

                                      // Dates

                                      for (let day = 1; day <= totalDays; day++) {

                                        const today = new Date();

                                        const isToday =
                                          day === today.getDate() &&
                                          month === today.getMonth() &&
                                          year === today.getFullYear();

                                        days.push(
                                          <div
                                            key={day}
                                            className={`calendarDate ${
                                              isToday ? "activeDate" : ""
                                            }`}
                                          >
                                            {day}
                                          </div>
                                        );
                                      }

                                      return days;

                                    })()
                                  }

                                </div>
                    </div>
                      
          :
          
                    <div className="holeavediv bg-white ">

                            {/* HEADER */}

                            <div className="d-flex justify-content-between align-items-center ">

                              <h5 className="fw-bold m-0 text-dark">
                                Corporate Holidays
                              </h5>

                              <span className="badge holeavebadge bg-primary rounded-pill">
                                {
                                  hoLeaveData.filter(
                                    item => new Date(item.date) >= new Date(new Date().setHours(0,0,0,0))
                                  ).length
                                }
                              </span>

                            </div>

                            {/* HOLIDAY LIST */}

                            <div className="row mt-4">

                              {/* LEFT SIDE */}

                              <div className="col-6 ">

                               {
                                  hoLeaveData.slice(0, 6).map((item, index) => {

                                    const isPast =
                                      new Date(item.date) <
                                      new Date(new Date().setHours(0,0,0,0));

                                    return (

                                      <div
                                        className="d-flex text-start hocards"
                                        key={index}
                                      >

                                        <div className="w-100">

                                          <p
                                            className={`holeaveTitle ${
                                              isPast ? "text-danger" : "text-dark"
                                            }`}
                                          >

                                            {item.Holidays}

                                          </p>

                                          <p className="text-secondary holeaveDate">

                                            {
                                              new Date(item.date)
                                                .toLocaleDateString("en-GB", {
                                                  day: "numeric",
                                                  month: "numeric",
                                                  year: "numeric"
                                                })
                                            }

                                          </p>

                                        </div>

                                      </div>
                                    );
                                  })
                                }

                              </div>

                              {/* RIGHT SIDE */}

                              <div className="col-6 ">

                                {
                                    hoLeaveData.slice(6, 12).map((item, index) => {

                                      const isPast =
                                        new Date(item.date) <
                                        new Date(new Date().setHours(0,0,0,0));

                                      return (

                                        <div
                                          className="d-flex text-start hocards"
                                          key={index}
                                        >

                                          <div className="w-100">

                                            <p
                                              className={`holeaveTitle ${
                                                isPast ? "text-danger" : "text-primary"
                                              }`}
                                            >

                                              {item.Holidays}

                                            </p>

                                            <p className="text-secondary holeaveDate">

                                              {
                                                new Date(item.date)
                                                  .toLocaleDateString("en-GB", {
                                                    day: "numeric",
                                                    month: "numeric",
                                                    year: "numeric"
                                                  })
                                              }

                                            </p>

                                          </div>

                                        </div>
                                      );
                                    })
                                  }

                              </div>

                            </div>

                          </div>
          }

          </motion.div>

        </motion.div>

        {/* FULL WIDTH */}
        <motion.div className="bottom-wide2 Desk"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          >

    {/* HEADER */}
    <div className="leaveHeader d-flex justify-content-between">

      <h2>Management Desk</h2>

      <button
        className="btn btn-sm btn-secondary rounded-3"
        onClick={() => navigate("/dashboard/management")}
      >
        View Details
      </button>

    </div>

    {/* CONTENT */}
    {
      loading ? (

        <div className="deskLoading">
          Loading...
        </div>

      ) : (

      <div
          id="managementCarousel"
          className="carousel slide"
          // data-bs-ride="carousel"
          // data-bs-interval="2500"
          // data-bs-wrap="true"
        >

          <div className="carousel-inner">

            {
              mdeskData.slice().reverse()
                .reduce((rows, item, index) => {

                  if (index % 3 === 0) {
                    rows.push(mdeskData.slice().reverse().slice(index, index + 3));
                  }

                  return rows;

                }, [])
                .map((group, groupIndex) => (

                  <div
                    key={groupIndex}
                    className={`carousel-item ${
                      groupIndex === 0 ? "active" : ""
                    }`}
                  >

                    <div className="deskGrid">

                      {
                        group.map((item) => (

                          <div
                            key={item.id}
                            className="deskCard"
                          >

                            {/* TITLE */}
                            <h5 className="deskTitle">
                              {item.title}
                            </h5>

                            {/* IMAGE */}
                            <div className="deskImage">

                              <img
                                src={`data:image/jpeg;base64,${item.imageBase}`}
                                alt={item.title}
                              />

                            </div>

                          </div>
                        ))
                      }

                    </div>

                  </div>
                ))
            }

          </div>

        </div>
            )
          }

        </motion.div>

          {/* BOTTOM */}
          <motion.div className="bottom-row"   variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            >

            <motion.div className="box bottom-left Awards"
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                >

                {/* HEADER */}
                <div className="leaveHeader d-flex justify-content-between w-100">

                  <h2>Awards</h2>

                  <button
                    className="btn btn-sm btn-secondary rounded-3"
                    onClick={() => navigate("/dashboard/awards")}
                  >
                    View Details
                  </button>

                </div>

                {/* CONTENT */}
                <div className="awardsContent">

                  {
                    loading ? (

                      <div className="awardsLoading">
                        Loading...
                      </div>

                    ) : (

                      <div className="awardsGrid">

                        {
                          awardData.slice(0,4).map((item) => (

                            <div
                              key={item.id}
                              className="awardCard"
                            >

                              {/* IMAGE */}
                              <div className="awardImage">

                                <img
                                  src={`data:image/jpeg;base64,${item.imageBase}`}
                                  alt={item.title}
                                  className="aimg"
                                />

                              </div>


                            </div>
                          ))
                        }

                      </div>
                    )
                  }

                </div>

              </motion.div>

            <motion.div className="bottom-center"  variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              >

            <div className="box strip-top Requests requestCard">

                <div className="container-fluid h-100">

                  <div className="row h-100 align-items-center">

                    {/* LEFT */}

                    <div className="col-8 reqleft">

                      <p className="rHeader mb-2">
                        Requests
                      </p>

                      <p className="reqlist">

                        ON DUTY, EXTRA DUTY, MISSED SWIPE 

                      </p>
                        <button className="reqBtn text-white" onClick={() => navigate('/dashboard/request')}>
                          Apply
                        </button>
                    </div>

                    {/* RIGHT */}

                    <div className="col-4 reqright text-center">

                      <div className="reqImageWrapper">

                        <img
                          src={form}
                          alt="form"
                          className="reqImage"
                        />

                      </div>

                      

                    </div>

                  </div>

                </div>

              </div>

              <div className="box strip-bottom Feedbacks">
                {/* HEADER */}
                  <div className="container-fluid h-100">

                  <div className="row h-100 align-items-center ">

                    {/* LEFT */}

                    <div className="col-12 reqleft ">

                      <p className="rHeader mb-2">
                        Feedback
                      </p>

                      <p className="feedContent d-flex justify-content-between py-lg-2">

                        <div className="d-flex gap-3 emoji ">
                          <i class="fa-regular fa-face-grin"></i>
                          <i class="fa-regular fa-face-meh"></i>
                          <i class="fa-regular fa-face-frown"></i>
                        </div>

                        <button className="reqBtn feedbackbtn text-white" onClick={() => navigate('/dashboard/feedback')}>
                          Give Your Thoughts
                        </button>
                      </p>
                      
                    </div>

                  

                  </div>

                </div>
              </div>

            </motion.div>

            <motion.div className="box bottom-right Contacts contactsBox"   variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              >

              {/* HEADER */}

              <div className="contactsHeader">

                <h2>Contacts</h2>

                <button
                  className="contactViewBtn"
                  onClick={() => navigate("/dashboard/contacts")}
                >
                  View More
                </button>

              </div>

              {/* BODY */}

              <div className="contactsBody row g-3">

                {/* CORPORATE */}

                <div className="col-6">

                  <div className="contactSection">

                    <div className="contactSectionTitle corporateTitle">
                      Corporate
                    </div>

                    <div className="contactList">

                      {
                        contactData
                          .filter(item => item.location === "Corporate")
                          .slice(0, 5)
                          .map((item, index) => (

                            <div
                              key={index}
                              className="contactCard"
                            >

                              <div className="contactName">
                                {item.name}
                              </div>

                              <div className="contactDesignation">
                                {item.designation}
                              </div>

                              <div className="contactPhone">
                                📞 {item.phone}
                              </div>

                            </div>
                          ))
                      }

                    </div>

                  </div>

                </div>

                {/* STORE */}

                <div className="col-6">

                  <div className="contactSection">

                    <div className="contactSectionTitle storeTitle">
                      Store
                    </div>

                    <div className="contactList">

                      {
                        contactData
                          .filter(item => item.location === "Store")
                          .slice(0, 5)
                          .map((item, index) => (

                            <div
                              key={index}
                              className="contactCard"
                            >

                              <div className="contactName">
                                {item.name}
                              </div>

                              <div className="contactDesignation">
                                {item.designation}
                              </div>

                              <div className="contactPhone">
                                📞 {item.phone}
                              </div>

                            </div>
                          ))
                      }

                    </div>

                  </div>

                </div>

              </div>

            </motion.div>

          </motion.div>

      </motion.div>

 

    </div>

    {
  showTop && (

    <motion.button
      className="scrollTopBtn"
      onClick={scrollToTop}

      initial={{
        opacity: 0,
        scale: 0.5
      }}

      animate={{
        opacity: 1,
        scale: 1
      }}

      exit={{
        opacity: 0,
        scale: 0.5
      }}

      whileHover={{
        scale: 1.1
      }}

      whileTap={{
        scale: 0.9
      }}
    >

      <i class="fa-solid fa-angles-up"></i>

    </motion.button>
  )
}


      {/* FOOTER */}
        {/* <div className="footerSection text-center fw-bold shadow">
          <span className="copyright">&#169;</span> 2026 POTHYS SWARNA MAHAL. All Rights Reserved.
        </div> */}

    </>

  )
}

export default Main
